// extracted by mini-css-extract-plugin
module.exports = {"market-popover":"market-popover_market-popover___dFtq"};